import script from "./EditInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./EditInfo.vue?vue&type=script&setup=true&lang=js"

import "./EditInfo.vue?vue&type=style&index=0&id=ba3a38fe&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba3a38fe"]])

export default __exports__